import { blockCategories } from '../../categories';

export const MENU_DEFAULTS = {
    tagName: 'nav',
    attributes: { class: 'recursive-menu' },

};

export const MENU_STYLES = {
    placeholder: {
        padding: '20px',
        'text-align': 'center',
        color: '#666',
    },
    menuList: {
        'list-style': 'none',
    },
    menuItem: {
        padding: '8px 12px',
        position: 'relative',
    },
};

export const BLOCK_CONFIG = {
    label: 'Rekursives Menü',
    category: blockCategories.advance,
    content: { type: 'recursive-menu' },
    attributes: { class: 'gjs-block-recursive-menu' },
    media: `<svg viewBox="0 0 24 24">
      <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"></path>
    </svg>`,
};

export const TIMING_CONSTANTS = {
    INITIALIZATION_DELAY: 300,
    VIEW_UPDATE_DELAY: 100,
    TRAIT_CHANGE_DELAY: 50,
    ATTRIBUTE_CHANGE_DELAY: 50,
    TRAIT_BUILD_DELAY: 10,
    EDITOR_TRIGGER_DELAY: 50,
    COMPONENT_READY_RETRY: 100,
};

export const CSS_CLASSES = {
    RECURSIVE_MENU: 'recursive-menu',
    MENU_CONTAINER: 'menu-container',
    MENU_LIST: 'menu-list',
    MENU_ITEM: 'menu-item',
    MENU_ITEM_TEXT: 'menu-item-text',
    MENU_PLACEHOLDER: 'menu-placeholder',
    HAS_CHILDREN: 'has-children',
    BLOCK_CLASS: 'gjs-block-recursive-menu',
};

export const TRAIT_TYPES = {
    RECURSIVE_MENU_SELECT: 'recursive-menu-select',
};

export const DATA_ATTRIBUTES = {
    MENU_LEVEL: 'data-menu-level',
    MENU_ITEM: 'data-menu-item',
    MENU_TYPE: 'data-menu-type',
    ITEM_INDEX: 'data-item-index',
};
